/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import type { ReactNode } from 'react';

import { css, jsx } from '@compiled/react';

const spacingWrapperContainerStyles = css({
	width: '100%',
});

const spacingWrapperStyles = css({
	flex: '1 0 100%',
	marginLeft: 'auto',
	marginRight: 'auto',
	maxWidth: '1320px',
	// eslint-disable-next-line @atlaskit/design-system/use-tokens-space
	paddingInline: '60px',
	'@media (max-width: 30rem)': {
		// eslint-disable-next-line @atlaskit/design-system/use-tokens-space
		paddingInline: '30px',
	},
});

type SpacingWrapperProps = {
	children: ReactNode;
	className?: string;
};

export function SpacingWrapper({ children, className }: SpacingWrapperProps): JSX.Element {
	return (
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
		<div css={spacingWrapperContainerStyles} className={className}>
			{/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop */}
			<div css={spacingWrapperStyles}>{children}</div>
		</div>
	);
}
